const diff = require('diff')

export const copyToClipboard = text => {
    const textArea = document.createElement('textarea')
    textArea.value = text

    // Avoid scrolling to bottom
    textArea.style.top = '-1000px'
    textArea.style.left = '-1000px'
    textArea.style.position = 'absolute'

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    var result

    try {
        result = document.execCommand('copy')
    } catch (err) {
        result = false
    }

    document.body.removeChild(textArea)

    return result
}

export const isASCII = str => {
    if (typeof str !== 'string') {
        return false
    }
    for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 127) {
            return false
        }
    }
    return true
}

export const doesStringRepresentBoolean = str => ['true', 'false'].includes(str.toLowerCase())
export const doesStringRepresentNumber = str => !isNaN(Number(str))

export const isValidHttpUrl = string => {
    let url
    try {
        url = new URL(string)
    } catch (_) {
        return false
    }
    return url.protocol === 'http:' || url.protocol === 'https:'
}

export const highlightDifferences = (actualOutput, expectedOutput, exactMatch = false, ignoreCase = false) => {
    // const formattedActualOutput = actualOutput
    const formattedActualOutput = actualOutput.replace(/<br\/>/g, '\n').replace(/&nbsp;/g, ' ')
    const formattedExpectedOutput = expectedOutput
    let output = ''
    let expected = ''

    const differences = diff.diffChars(formattedActualOutput, formattedExpectedOutput, {
        ignoreCase,
    })
    differences.forEach(part => {
        part.value = part.value.replace(/\n/g, '<br/>').replace(/ /g, '&nbsp;')
        if (part.added) {
            expected += `<ins title="Added">${part.value}</ins>`
        } else if (part.removed) {
            output += `<del title="Removed">${part.value}</del>`
        } else {
            output += part.value
            expected += part.value
        }
    })

    console.log(output)
    return { output, expectedOutput: expected }
}

export const getNameInitials = name =>
    name
        ?.split(' ')
        ?.map(word => word[0]?.toUpperCase())
        ?.join('')
